import UserService from 'services/UserService'
import UrlHistoryService from 'services/UrlHistoryService'
import UserAdapter from 'common/adapters/UserAdapter'
import NotificationConductor from 'common/conductors/NotificationConductor'
import selfExclusionNotification from 'features/SelfExclusion/SelfExludedNotification'
import { setCookie } from 'services/CookieService'
import GamesService from 'services/GamesService'

export const signupHelper = (match, history) => {
    const loginAction = (withRegistration = false) => {
        setCookie('isItInitialLogin', 'true', 90)
        localStorage.setItem('logged', 'true')
        UserService.attachUser()
        UserService.setIsUserLoggedIn((userData) => {
            UserService.showPinLoginPopup()
            UrlHistoryService.openUserAreaAfterLogin(history)
            window.dataLayer.push({ event: 'login', userId: userData.userId })
            withRegistration &&
                window.dataLayer.push({
                    event: 'casinogo.completeRegistration',
                    userId: userData.userId,
                })
        })
        selfExclusionNotification()
    }

    if (match.params && match.params.type === 'signup') {
        UserAdapter.register()
            .then((res) => {
                if (res.success) {
                    loginAction(true)
                    NotificationConductor.success('Velkommen til Casinogo')
                } else {
                    res.errorMessage &&
                        NotificationConductor.error(res.errorMessage.toString())
                }
            })
            .catch((error) => {
                NotificationConductor.error(error.toString())
                history.push(`/mitid-verify/error`)
            })
    } else {
        loginAction()
    }

    // Check if there's a pending game to launch
    // Use setTimeout to ensure login is complete before launching the game
    setTimeout(() => {
        GamesService.launchPendingGame(history, () => {
            history.push('/')
        })
    }, 500)

    return null
}
